import { FaPlus } from "react-icons/fa";
import CardHeader from "../../atoms/CardHeader";
import IconButton from "../../atoms/IconButton";
import { useParams } from "react-router-dom";
import { useSession } from "../../../context/SessionContext";
import { useCallback, useEffect, useState } from "react";
import useModal from "../../../hooks/useModal";
import FacturasTable from "../../organisms/inmueble/inmuebleDocsTables/facturas/FaturasTable";
import Card from "../../atoms/Card";
import Modal from "../../molecules/Modal";
import CreateFactura from "../../organisms/inmueble/inmuebleDocsTables/facturas/CreateFactura";
import { GET_INMUEBLE_ID } from "../../../api/apiInmuebles";
import { PropagateLoader } from "react-spinners";
import { GET_FACTURAS } from "../../../api/apiFacturas";
import { GET_RENTA_ARCHIVOS } from "../../../api/apiFiles";
import SubHeading from "../../atoms/SubHeading";
import Breadcrumb from "../../molecules/Breadcrumb";
import { getInmobiliaria } from "../../../utils/getInmobiliaria";

const InmuebleFacturasTemplate = () => {
    const { idUser, id, im } = useParams();
    const { user } = useSession();
    const [loading, setLoading] = useState();
    const [facturas, setFacturas] = useState();
    const [inmueble, setInmueble] = useState();
    const { open, isOpen, close } = useModal();
    const [datosFacturacion, setDatosFacturacion] = useState(null);

    useEffect(() => {
        const getInmueble = async () => {
            try {
                const inmuebleData = await GET_INMUEBLE_ID(Number(im));
                setInmueble(inmuebleData);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        getInmueble();
    },[im]);

    const getFacturas = useCallback ( async () => {
        setLoading(true);
        try {
            const rentaData = await GET_RENTA_ARCHIVOS(Number(im));
            const activeRenta = rentaData.find(r => r.isActive);

            let df = activeRenta?.datos_facturacion;

            if (typeof df === "string") {
                try {
                    df = JSON.parse(df);
                } catch (error) {
                    console.error("Error al parsear datos_facturacion:", error);
                    df = {};
                }
            }

            setDatosFacturacion(df || {});
        } catch (error) {
            console.error(error);
        }

        try {
            const facturasData = await GET_FACTURAS(Number(im));
            setFacturas(facturasData);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    },[im]);

    const getInmueble = useCallback ( async () => {
        if (!im) return;
        try {
                const inmuebleData = await GET_INMUEBLE_ID(Number(im));
                setInmueble(inmuebleData);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        }, [im]);

    useEffect(() => {
        getFacturas();
    }, [getFacturas]);

    useEffect(() => {
        if (!im) return;
        getInmueble();
    },[getInmueble, im]);

    const linksAdmin = [
        { label: "Inmobiliarias", to: "/inmobiliarias" },
        { label: getInmobiliaria(id), to: `/inmobiliarias/${id}` },
        { label: inmueble?.name, to: `/inmobiliarias/${id}/${im}` },
        { label: "Facturas", to: null },
    ];

    const linksUser = [
        { label: inmueble?.name, to: `/${idUser}/${im}` },
        { label: "Facturas", to: null },
    ];


    if (loading) return <div className="w-full h-screen flex items-center justify-center"> <PropagateLoader color="red"/> </div>;

    return(
        <div className="flex flex-col gap-4">
            <CardHeader
                          left={
                            <Breadcrumb
                              items={user?.role === "Resident" ? linksUser : linksAdmin}
                            />
                          }
                right={user?.role !== "Resident" && !loading ?
                        <IconButton icon={FaPlus} bgColor="bg-green-600" onClick={open}/>
                    :
                        <IconButton icon={FaPlus} bgColor="bg-white" disabled/>
                }
            />
            <Card>
            {datosFacturacion && (
                <>
                    <SubHeading text="Datos de facturación" color="blue" />
                    <div className="w-full grid grid-cols-2">
                        <p><strong>Razón Social:</strong> {datosFacturacion.razonSocial || "N/A"}</p>
                        <p><strong>RFC:</strong> {datosFacturacion.rfc || "N/A"}</p>
                        <p><strong>Uso CFDI:</strong> {datosFacturacion.usoCFDI || "N/A"}</p>
                        <p><strong>Email:</strong> {datosFacturacion.email || "N/A"}</p>
                    </div>
                </>
            )}
                <FacturasTable data={facturas} loading={loading} refetch={getFacturas} />
            </Card>
            {isOpen &&
                <Modal title="Subir factura" onClose={close}>
                    <CreateFactura onClose={close} refetch={getFacturas} inmueble={inmueble} />
                </Modal>
            }
        </div>
    );
};

export default InmuebleFacturasTemplate;